/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import UserMenu from '../../Components/UserMenu/UserMenu.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import ReportsPageSidebarPropTypes from './Reports.page.sidebar.props';
import reportsPageStyles from './Reports.page.styles';

/**
 * ReportsPageSidebarComponent
 * @export
 * @class ReportsPageSidebarComponent
 * @extends {React.Component<ReportsPageSidebarComponentComposedProps, ReportsPageSidebarComponentState>}
 */
export class ReportsPageSidebarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<ReportsPageSidebarComponentProps>}
   * @memberof ReportsPageSidebarComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ReportsPageSidebar`}
   * @memberof ReportsPageSidebarComponent
   */
  static displayName = `ReportsPageSidebar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof ReportsPageSidebarComponent
   */
  static propTypes = ReportsPageSidebarPropTypes;

  /**
   * Data specific to the `<ReportsPageSidebar />` instance
   * @type {ReportsPageSidebarComponentState}
   * @memberof ReportsPageSidebarComponent
   */
  state = {};

  /**
   * Render the sidebar
   * @returns {React.Component} The rendered `<ReportsPageSidebar />`
   * @memberof ReportsPageSidebarComponent
   */
  render() {
    return <UserMenu showAvatar={false} />;
  }
}

/** @type {React.ComponentClass<ReportsPageSidebarComponentProps>} */
const ReportsPageSidebar = compose(withStyles(themeCreateInjectableStyles(reportsPageStyles), { withTheme: true }))(ReportsPageSidebarComponent);

export default ReportsPageSidebar;
